// extracted by mini-css-extract-plugin
module.exports = {"CountriesFeature":"wm_a bhv_b"};